function fromBase64url(value) {
  const base64 = value.replace(/-/g, "+").replace(/_/g, "/").padEnd(Math.ceil(value.length / 4) * 4, "=");
  const binary = window.atob(base64);
  return Uint8Array.from(binary, (char) => char.charCodeAt(0)).buffer;
}

function toBase64url(value) {
  const bytes = new Uint8Array(value);
  let binary = "";
  bytes.forEach((byte) => { binary += String.fromCharCode(byte); });
  return window.btoa(binary).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}

function descriptorFromJSON(item) {
  return { ...item, id: fromBase64url(item.id) };
}

export function registrationOptionsFromJSON(options) {
  return {
    ...options,
    challenge: fromBase64url(options.challenge),
    user: { ...options.user, id: fromBase64url(options.user.id) },
    excludeCredentials: (options.excludeCredentials || []).map(descriptorFromJSON),
  };
}

export function authenticationOptionsFromJSON(options) {
  return {
    ...options,
    challenge: fromBase64url(options.challenge),
    allowCredentials: (options.allowCredentials || []).map(descriptorFromJSON),
  };
}

export function credentialToJSON(credential) {
  const response = credential.response;
  const payload = {
    id: credential.id,
    rawId: toBase64url(credential.rawId),
    type: credential.type,
    authenticatorAttachment: credential.authenticatorAttachment,
    clientExtensionResults: credential.getClientExtensionResults(),
    response: {
      clientDataJSON: toBase64url(response.clientDataJSON),
    },
  };
  if (response.attestationObject) payload.response.attestationObject = toBase64url(response.attestationObject);
  if (response.authenticatorData) payload.response.authenticatorData = toBase64url(response.authenticatorData);
  if (response.signature) payload.response.signature = toBase64url(response.signature);
  if (response.userHandle) payload.response.userHandle = toBase64url(response.userHandle);
  if (response.getTransports) payload.response.transports = response.getTransports();
  return payload;
}
